import BASEURLGESTTOR from '../api/gesttor'
import { payloadAdicionarContato, payloadAtualizarComunicado, payloadCadastrarComunicado, payloadAtualizarContato, payloadCriarTag, payloadCadastrarContato } from '../../interfaces/atendimento'

export function buscarComunicados() {
    return BASEURLGESTTOR.get('/comunicados')
}

export function filtrarComunicado({ usuario, grupo, situacao, dataInicial, dataFinal, titulo }: any) {
    return BASEURLGESTTOR.get(`/comunicados?usuario=${usuario || ""}&grupo=${grupo || ""}&situacao=${situacao || ""}&dataInicio=${dataInicial || ""}&dataFinal=${dataFinal || ""}&titulo=${titulo || ""}`)
}

export function cadastrarComunicado(payload: payloadCadastrarComunicado) {
    return BASEURLGESTTOR.post('/comunicados', payload)
}

export function atualizarComunicado(payload: payloadAtualizarComunicado, idComunicado: string) {
    return BASEURLGESTTOR.patch(`/comunicados/${idComunicado}`, payload)
}

export function buscarTags() {
    return BASEURLGESTTOR.get('/tags')
}

export function listarContatos(idComunicado: string) {
    return BASEURLGESTTOR.get(`/destinatarios/${idComunicado}`)
}

export function listarTodosContatos() {
    return BASEURLGESTTOR.get(`/contato`)
}

export function listarContatosPorIdCadastro(idCadastro: string) {
    return BASEURLGESTTOR.get(`/contato/${idCadastro}`)
}

export function adicionarContato(payload: payloadAdicionarContato, idComunicado: string) {
    return BASEURLGESTTOR.post(`/destinatarios/${idComunicado}`, payload)
}

export function listarTodosCandidatos(notificacaoEmail: string, notificacaoWhatsapp: string) {
    return BASEURLGESTTOR.get(`/listarCandidatosParaComunicado?notificacaoEmail=${notificacaoEmail}?notificacaoWhatsapp=${notificacaoWhatsapp}`)
}

export function cancelarDestinatario(idDestinatario: string) {
    return BASEURLGESTTOR.patch(`/destinatarios/${idDestinatario}`)
}

export function atualizarContato(idContato: string, payload: payloadAtualizarContato) {
    return BASEURLGESTTOR.patch(`/contato/${idContato}`, payload)
}

export function criarTag(payload: payloadCriarTag) {
    return BASEURLGESTTOR.post(`/tags`, payload)
}

export function cadastrarContato(payload: payloadCadastrarContato) {
    return BASEURLGESTTOR.post(`/contato`, payload)
}

export function removerTagContato(idTag: string) {
    return BASEURLGESTTOR.delete(`/tags/${idTag}`)
}

export function removerContato(idContato: string) {
    return BASEURLGESTTOR.delete(`/contato/${idContato}`)
}